import { appNabarRoutes } from "../../../router/AppNavbarRoutes";
import { SingleTemplateForm } from "./SingleTemplateForm";
import { TemplatesTableView } from "./TemplatesTableView";

export const templatesRoutes = [
    { path: appNabarRoutes.settings.template, exact: true, element: <TemplatesTableView /> },
    { path: `${appNabarRoutes.settings.template}/manage`, exact: true, element: <SingleTemplateForm /> },
    { path: `${appNabarRoutes.settings.template}/manage/:templateCode`, exact: true, element: <SingleTemplateForm /> },
]

